import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

type Props = {
  id: string;
  title: string;
  children: ReactNode;
};

/** An anchored docs section: `#id` is a stable deep-link target. */
export function DocsSection({ id, title, children }: Props) {
  return (
    <Box component="section" id={id} sx={{ scrollMarginTop: 32 }}>
      <Typography variant="h2" sx={{ fontSize: '1.75rem', mb: 2 }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
}
